import {Component, ElementRef, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef,OnChanges} from '@angular/core';
import {LoginService} from '../shared/services/login.service';
import {Router} from '@angular/router';
//import * as moment from 'moment'
import {HttpErrorResponse} from '@angular/common/http';
import {HydrantLog} from '../shared/data-objects/hydrant-log';
import {HydrantLogService} from '../shared/services/hydrantlog.service';
import {User} from '../shared/data-objects/user';
import {FormControl, Validators} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-create-log',
  templateUrl: './create-log.component.html'
})

export class CreateLogComponent implements OnInit, AfterViewInit {
  hydrantLogs: HydrantLog[];
  hydrantLogsToBeSubmitted :HydrantLog[]
  errorMessage: string;
  isRequesting: boolean;
  permitNoControl: FormControl;
  permitNumber: string;
  date12:Date
  

  constructor(private hydrantLogService: HydrantLogService, private loginService: LoginService, private router: Router,private change:ChangeDetectorRef,public datepipe: DatePipe) {
    let noOfLogs:number=5
    this.addHydrantLogsRows(noOfLogs)
    this.datepipe= new DatePipe('en-US')
  }

  ngAfterViewInit(): void {
    /*this.focusInputElement.nativeElement.focus();*/
    this.change.detectChanges()
  }
 
  addLogs(noOfLogs){
    this.addHydrantLogsRows(noOfLogs)
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addHydrantLogsRows(noOfLogs){
    if(!this.hydrantLogs){
      this.hydrantLogs = [];
      }
    let noOfRows:any[]=[]
    for (var i = 1; i <= noOfLogs; i++) {

      const row1: HydrantLog = new HydrantLog();

      row1.accountNumber = '';
      row1.vehicleRegistrationNo = '';
      row1.permitNo = '';
      row1.streetNo = '';
      row1.streetName = '';
      row1.suburb = '';
      row1.month = '';
      row1.kiloLitreTaken =null;

      this.hydrantLogs.push(row1)
      //noOfRows.push(i.toString());
    }
  }

  ngOnInit() {
    this.loginService.refreshToken();
  }
  
  get monthOptions(): SelectItem[] {
    return [{label: 'Please select...', value: ''}, {label: 'Jan'+" "+new Date().getFullYear(), value: 'January'+" "+new Date().getFullYear()},
      {label: 'Feb'+" "+new Date().getFullYear(), value: 'February'+" "+new Date().getFullYear()},
      {label: 'Mar'+" "+new Date().getFullYear() , value: 'March'+" "+new Date().getFullYear()},
      {label: 'Apr'+" "+new Date().getFullYear(), value: 'April'+" "+new Date().getFullYear()},
      {label: 'May'+" "+new Date().getFullYear(), value: 'May'+" "+new Date().getFullYear()},
      {label: 'Jun'+" "+new Date().getFullYear(), value: 'June'+" "+new Date().getFullYear()},
      {label: 'Jul'+" "+new Date().getFullYear(), value: 'July'+" "+new Date().getFullYear()},
      {label: 'Aug'+" "+new Date().getFullYear(), value: 'August'+" "+new Date().getFullYear()},
      {label: 'Sep'+" "+new Date().getFullYear(), value: 'September'+" "+new Date().getFullYear()},
      {label: 'Oct'+" "+new Date().getFullYear(), value: 'October'+" "+new Date().getFullYear()},
      {label: 'Nov'+" "+new Date().getFullYear(), value: 'November'+" "+new Date().getFullYear()},
      {label: 'Dec'+" "+new Date().getFullYear(), value: 'December'+" "+new Date().getFullYear()}];
  }
  get invalid(): boolean {

    let hydrantLog = [];
    hydrantLog = [...this.hydrantLogs];
    let returnValue:boolean=false
    const user: User = this.loginService.getUser();
    let fullName = '';
    if (user.firstName) {fullName = user.firstName; }
    if (user.lastName) {fullName += ' ' + user.lastName; }

    hydrantLog.map(x=>{
   
       x.accountNumber= user.accountNumber
       x.permitHolderName= user.accountName ? user.accountName : fullName;
       //x.month = x.month ? moment(x.month).format('MMM-YYYY').trim():"";
       x.month =x.month ? this.datepipe.transform(x.month,'MMM-yyyy'):"";
    })
      

//  ingnore empty rows of hydrant logs 
     const hydrantLogsLenght= hydrantLog.length
hydrantLog.forEach(x=>{

 if(hydrantLogsLenght > 1){
      if (x.permitNo !=='' && x.vehicleRegistrationNo !== '' && x.month !== ''
      && x.suburb !== ''
      && x.kiloLitreTaken) {
        
        hydrantLog= hydrantLog.filter(x=>x.permitNo)
      }
    }
      
    })

//  

    hydrantLog.map(x=>{

    if (x.permitNo ==='' || x.vehicleRegistrationNo === '' || x.month === ''
      || x.suburb === ''
      || x.kiloLitreTaken === 0) {
      this.errorMessage = 'Please select enter valid data.';
      returnValue= true;
      return 
    }
    const capacity: Number = x.kiloLitreTaken;
    if (capacity < 1 || capacity > 20000) {
      this.errorMessage = 'Please select enter valid value for kilo litres taken (between 1 and 20000).';
      returnValue= true;
      return 
    }
    })
   
   if(!returnValue)
   {
     this.hydrantLogsToBeSubmitted=[...hydrantLog]
   }
  return returnValue;
}

  submitLog(): void {
    if (this.invalid) {
      return;
    }
    this.isRequesting = true;
    this.errorMessage = '';
    const user: User = this.loginService.getUser();
    //this.hydrantLogs[0].permitNo = this.permitNumber;
    // let fullName = '';
    // if (user.firstName) {fullName = user.firstName; }
    // if (user.lastName) {fullName += ' ' + user.lastName; }

    // this.hydrantLogsToBeSubmitted.map(x=>{
    //    x.accountNumber= user.accountNumber
    //    x.permitHolderName= user.accountName ? user.accountName : fullName;
    //    x.month = moment(x.month).format('MMM-YYYY').trim();
    // })

    //const permitName = user.accountName ? user.accountName : fullName;
    this.hydrantLogService.register(this.hydrantLogsToBeSubmitted,
      this.submitOkCb.bind(this), this.submitErrorCb.bind(this));
  }

  submitOkCb(ok: boolean): void {
    this.isRequesting = false;
    if (ok) {
      this.router.navigate(['/logConfirm']);
      // this.errorMessage = 'Done';
    } else {
      this.errorMessage = 'Server Error';
    }
  }

  submitErrorCb(err: HttpErrorResponse): void {
    this.isRequesting = false;
    if (err) {
      if (err.error.err instanceof Array) {
        const message: string = err.error.err.toString();
        const splicedMessage: string[] = message.split(',');
        if (splicedMessage.length > 0) {
          this.errorMessage = splicedMessage.join('\n');
        }
      } else {
        this.errorMessage = 'Could not submit the log.';
      }
    } else {
      this.errorMessage = 'Server Error';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/hydrant-log/create-log.component.ts